import React from "react";

const DocumentationPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Documentation
        </h1>

        <div className="text-gray-600 dark:text-gray-300 text-xl font-medium mb-6">
          Coming Soon
        </div>

        <p className="text-gray-500 dark:text-gray-400 text-base leading-relaxed">
          We're working hard to bring you comprehensive documentation for
          OSMOAIR. Check back soon for detailed guides and tutorials.
        </p>
      </div>
    </div>
  );
};

export default DocumentationPage;
